/**
 * 返回两个集合中相同的元素
 */
export function contains(array1,array2){
    var array3 = [];
    for(var i in array1){
        for(var j in array2){
            if(array2[j] == array1[i].functionId){
                array3.push(array1[i].functionId)
            }
        }
    }
    return array3;
}
export default{contains}


// WEBPACK FOOTER //
// ./src/utils/arrayUtils.js